module.exports = "varying vec3 vColor;\nvarying float vAlpha;\n\nvoid main() {\n    gl_FragColor = vec4(vColor, vAlpha);\n    // vec4(1.0, 0., 0., 1.);\n}"